import { render, staticRenderFns } from "./DialogStandardText.vue?vue&type=template&id=4e99dcc3"
import script from "./DialogStandardText.vue?vue&type=script&setup=true&lang=js"
export * from "./DialogStandardText.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports